// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0
//
//
// map real slider value to a value that is compatible with the summary backend

export const snapValues = [0, 0.23, 0.43, 0.62, 0.82, 1]; //for length slider

function mapSliderValue(x) {
  let mapping = [
    { x: snapValues[0], y: 0.25 },
    { x: snapValues[1], y: 0.5 },
    { x: snapValues[2], y: 1 },
    { x: snapValues[3], y: 2 },
    { x: snapValues[4], y: 5 },
    { x: snapValues[5], y: 10 },
  ];

  for (let i = 0; i < mapping.length - 1; i++) {
    const a = mapping[i];
    const b = mapping[i + 1];

    if (x >= a.x && x <= b.x) {
      const t = (x - a.x) / (b.x - a.x); // normalized x
      return a.y + t * (b.y - a.y); // linear interpolation
    }
  }

  if (x <= mapping[0].x) return mapping[0].y;
  if (x >= mapping[mapping.length - 1].x) return mapping[mapping.length - 1].y;
}

export default mapSliderValue;
